import { type ReactNode } from 'react';
import { Controller, type Control } from 'react-hook-form';
import { Dropdown } from '@ics-portal/guardian';
import { Section } from '@components/shared/Section';
import { type StringOption } from '@models/Option';
import { type User } from '@gql/graphql';
import { type ProjectFormAttributes } from '../../../ProjectForm';
import { ProjectFormAttributesInput } from '../../ProjectFormAttributes';

interface ProjectFormSidebarSectionProps {
    pid?: string;
    usersLoading: boolean;
    currentUser?: User;
    projectMembersOptions: StringOption[];
    control: Control<ProjectFormAttributes>;
}

export function ProjectFormSidebarSection({
    pid,
    usersLoading,
    currentUser,
    projectMembersOptions,
    control,
}: ProjectFormSidebarSectionProps): ReactNode {
    let securityResponsibleOptions: StringOption[] = [];
    if (pid) {
        securityResponsibleOptions = projectMembersOptions;
    } else if (currentUser) {
        securityResponsibleOptions = [
            {
                value: currentUser.id,
                label: `${currentUser.firstName} ${currentUser.lastName}`,
            },
        ];
    }

    return (
        <div
            className="flex flex-column gap-5 align-self-start"
            style={{ flex: 326 }}
        >
            <Section title="Security Responsible">
                <Controller
                    name="securityResponsibleID"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                        <Dropdown
                            className="w-full"
                            placeholder="Select security responsible"
                            options={securityResponsibleOptions}
                            loading={usersLoading}
                            disabled={!pid || usersLoading}
                            {...field}
                            onChange={(event) => {
                                field.onChange(event.target.value);
                            }}
                        />
                    )}
                />
            </Section>

            <Section title="Project Additional Properties">
                {!pid ? (
                    <p className="text-center text-xs">
                        Project Additional properties could be added later in
                        the <strong>Project</strong> tab on the{' '}
                        <strong>Project Settings</strong> page.
                    </p>
                ) : (
                    <ProjectFormAttributesInput />
                )}
            </Section>
        </div>
    );
}
